import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Engagement Message arrives with a Pre-styled configuration.
 * @memberOf Playtech.API.events
 * @event advanced-dialog-nongame
 * @type {callback}
 * @param {object} detials
 * @param {string} details.actionId - ID of action in IMS.
 * @param {object} details.actionInfo - Object that describes the dialog.
 * @param {object} details.windowSessionId - Window Session ID.
 * @example Playtech.on('advanced-dialog-nongame', ({
 *     actionId,
 *     actionInfo: {
 *         buttons,
 *         message
 *     },
 *     windowSessionId
 * }) => {
 *     const { buttons: popupButtons, onClose } = Playtech.API.popup.getButtons({ buttons, actionId, windowSessionId });
 *
 *     Playtech.API.popup.showPopup('common', {
 *         buttons: popupButtons,
 *         content: message,
 *         onClose
 *     });
 * });
 */
export const ADVANCED_DIALOG_NON_GAME = 'advanced-dialog-nongame';

export const useOnAdvancedDialogNonGame = (eventTarget: EventTarget): void => {
    const triggerAdvancedDialogNonGameEvent = useCallback((detail: {
        actionId: string;
        actionInfo: object;
    }) => {
        const event = new CustomEvent(ADVANCED_DIALOG_NON_GAME, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('advanced-dialog-nongame', triggerAdvancedDialogNonGameEvent);

        return () => {
            publicEventsAPIService.off('advanced-dialog-nongame', triggerAdvancedDialogNonGameEvent);
        };
    }, [triggerAdvancedDialogNonGameEvent]);
};
